export const TEXT = {
  ar: {
    dir: "rtl", title: "الصورة المرجعية", sub: "تُستخدم للتحقق من حضورك فقط", close: "إغلاق",
    preview: "معاينة الكاميرا الأمامية", photo: "الصورة الملتقطة",
    lighting: "الإضاءة", distance: "المسافة", stability: "الثبات",
    look: "انظر إلى الكاميرا وافتح عينيك",
    capture: "التقاط الصورة", retake: "إعادة", approve: "اعتماد الصورة",
    readyTitle: "الصورة جاهزة للاعتماد", readySub: "إضاءة جيدة · وجه واضح · نظرة مستقيمة",
    starting: "جارٍ تشغيل الكاميرا…", denied: "اسمح بالوصول إلى الكاميرا من إعدادات المتصفح ثم أعد المحاولة",
    unavailable: "تعذّر تشغيل الكاميرا", pct: (n) => `${n}٪ جاهزية`,
  },
  en: {
    dir: "ltr", title: "Reference photo", sub: "Used only to verify your attendance", close: "Close",
    preview: "Front camera preview", photo: "Captured photo",
    lighting: "Lighting", distance: "Distance", stability: "Stability",
    look: "Look at the camera and open your eyes",
    capture: "Take photo", retake: "Retake", approve: "Use this photo",
    readyTitle: "Photo ready to use", readySub: "Good light · Clear face · Looking straight",
    starting: "Starting camera…", denied: "Allow camera access in your browser settings, then try again",
    unavailable: "The camera could not start", pct: (n) => `${n}% ready`,
  },
};

export const HINTS = {
  noFace: { level: "problem", ar: "ضع وجهك داخل الإطار", en: "Place your face inside the frame" },
  manyFaces: { level: "problem", ar: "يجب أن يظهر وجه واحد فقط", en: "Only one face should be visible" },
  tooDark: { level: "problem", ar: "الإضاءة ضعيفة، انتقل لمكان أكثر إضاءة", en: "Too dark, move to a brighter spot" },
  tooFar: { level: "problem", ar: "قرّب وجهك قليلاً من الكاميرا", en: "Move a little closer to the camera" },
  tooClose: { level: "problem", ar: "ابتعد قليلاً عن الكاميرا", en: "Move back a little" },
  center: { level: "adjusting", ar: "ضع وجهك في منتصف الإطار", en: "Center your face in the frame" },
  openEyes: { level: "adjusting", ar: "افتح عينيك وانظر إلى الكاميرا", en: "Open your eyes and look at the camera" },
  lookAhead: { level: "ok", ar: "إضاءة ممتازة، اثبت وانظر للأمام", en: "Great light, hold still and look ahead" },
  ready: { level: "ok", ar: "ممتاز، اضغط لالتقاط الصورة", en: "Perfect, tap to take the photo" },
};

export const STATUS = {
  waiting: { level: "waiting", ar: "بانتظار", en: "Waiting" },
  low: { level: "problem", ar: "ضعيفة", en: "Low" },
  good: { level: "ok", ar: "جيدة", en: "Good" },
  great: { level: "ok", ar: "ممتازة", en: "Great" },
  far: { level: "problem", ar: "بعيد", en: "Too far" },
  close: { level: "problem", ar: "قريب جداً", en: "Too close" },
  fit: { level: "ok", ar: "مناسبة", en: "Good" },
  checking: { level: "adjusting", ar: "جارٍ…", en: "Checking…" },
  steady: { level: "ok", ar: "ثابت", en: "Steady" },
};

export const LEVEL_COLORS = {
  ok: ["#0E7A4E", "#22B573"],
  problem: ["#B83A3A", "#E05A4E"],
  adjusting: ["#8A5A00", "#F2A93B"],
  waiting: ["#5B6573", "#C3CAD4"],
};
